import {vue, nextTick} from 'vue';
import * as syncApi from "@/modules/api/sync";
import {getCurrentLocalHistory} from "@/modules/localDB/bookQuery";
import {setLocalUnChanged} from "@/modules/localDB/toolHistory";
import config from "@/config/config.json";
import {forceLogout} from "@/modules/api/auth";
import * as auth from "@/modules/api/auth";
import {useTool} from "@/modules/reader/tools/tools";
import {useBookmark}  from "@/modules/reader/bookmark/bookmark";
import {useInlineExercise} from "@/modules/reader/inlineExercise/inlineExercise";
import {usePaging}  from "@/modules/reader/book/paging";
import {apiErrorHandler} from "@/modules/api/error";
import {i18n} from "@/modules/i18n/i18n";
import {isTouchDevice} from "@/modules/utils/deviceUtils";

const {setCurrentPage, pageState}  = usePaging();
/**
 * Restore data from server
 * @returns {Promise<unknown[]>}
 */
const restore = async ()=>{

    await checkToken();

    const updateTimeData = await syncApi.getUpdateTime();
    const {setCurrentPage}  = usePaging();
    const {updateAnswersFromRemote } = useInlineExercise();

    apiErrorHandler(updateTimeData);

    const inlineExerciseData = await getInlineHtmlAnswers({
        ebookcode:localStorage.ebookcode,
        file_list: [],
        membercode: localStorage.membercode
    });

    if (inlineExerciseData && inlineExerciseData.data.file_list) {
        let answers = [];
        for (let item of inlineExerciseData.data.file_list) {
            answers.push({
                exercisecode: item.filename,
                content:item.data
            })
        }

        if (updateTimeData.data.hasdata !== "true") {
            alert(i18n.t("info_msg_restore_success"));
        }
        await updateAnswersFromRemote(answers);
    }

    if (updateTimeData.data.hasdata === "true") {

        let promptMsg;
        let updateTime;
        let hasLocalHistoryChange = false;
        const localHistory = await getCurrentLocalHistory();

        //check to see if there is change to local history. If yes, ask user if overwriting local history with remote data or not.
        if (localHistory) {
            if (localHistory.pagesWithLocalChange || localHistory.isBookMarkChanged) {
                hasLocalHistoryChange = true;
            }
        }

        //TODO: i18n datetime format
        updateTime =  new Date(updateTimeData.data.updatetime.replace(/-/g, '/'));
        updateTime.setUTCHours(updateTime.getUTCHours()+8);

        if (hasLocalHistoryChange) {
            promptMsg = i18n.t("info_msg_restore_overwrite", {updateTime:updateTime});
        } else {
            promptMsg = i18n.t("info_msg_restore_confirm", {updateTime:updateTime});
        }

        if (window.confirm(promptMsg)) {

            await getEbookPrifle();
            const lastPageRead = await getLastRead();
            const userHistory = await getPagesWithHistory();
            const restoredData = await getResotredDataByPage(userHistory);

            if (restoredData) {
                console.log("@synchronizer has restore data")
                console.log(restoredData);
                //render drawing and notes from restored data:
                const remoteHistory = restoreToolHistoryToView(restoredData);
                console.log("remoteHistory");
                console.log(remoteHistory);
                //just simply get the restored bookmark pages:
                console.log("remote bookmarks:");
                console.log(userHistory.data.bookmarks)
                await restoreBookmarkHistoryToView(userHistory.data.bookmarks);
                await useTool().saveLocalFromRemote(remoteHistory);
                const result = await setCurrentPage(lastPageRead.data.LastReadKey);
                alert(i18n.t("info_msg_restore_success"));
                await result;
            }
        }
    } else {
       if (!inlineExerciseData.data.file_list) {
           alert(i18n.t("info_msg_backup_restore_null"))
       }
    }

}

/**
 * Check if token is valid
 * @returns {Promise<void>}
 */
const checkToken = async()=> {
    const tokenResult = await auth.checkToken(localStorage.accessToken);

    if (!localStorage.accessToken) {
        throw new Error(config.errorcode.invalid_token);
    }

    apiErrorHandler(tokenResult);
}

/**
 * Get ebookproifle, used in restore process
 * @returns {Promise<*>}
 */
const getEbookPrifle = async()=> {

    const ebookProfileResult = await syncApi.getEbookProfileUrl();
    apiErrorHandler(ebookProfileResult);
    return ebookProfileResult;

}

/**
 * Get the last read page, used in restore process
 * @returns {Promise<void>}
 */
const getLastRead = async()=> {

    //get last read page number. Note that it's zero-based
    const lastPageRead = await syncApi.getLastPageRead();
    apiErrorHandler(lastPageRead);
    return lastPageRead;

}

/**
 * Get the page numbers that contain user data, used in restore process
 * @returns {Promise<void>}
 */
const getPagesWithHistory = async()=> {

    const userHistory = await syncApi.getPagesWithHistory();
    apiErrorHandler(userHistory);
    return userHistory;

}

/**
 * Retrieve the main backup data, used in restore process
 * @returns {Promise<void>}
 */
const getResotredDataByPage = async(userHistory) => {
    //TODO: bookkmarks
    const brushIndexes = userHistory.data.brushindexes;
    const noteIndexes = userHistory.data.noteindexes;
    const allIndexes = brushIndexes.concat(noteIndexes);
    //get unique page numbers by merging all indexes
    const pageWithHistory = new Set(allIndexes);

    const pageHistoryPromises = [];
    for (let page of pageWithHistory) {
        pageHistoryPromises.push(await syncApi.getHistoryByPage(page));
    }

    const result = await Promise.all(pageHistoryPromises);
    return result;
}


/**
 *  Retrieve remote inline exercise data
 * @param data
 * @returns {Promise<*>}
 */
const getInlineHtmlAnswers = async(data) => {
    const answerData = await syncApi.getInlineHtmlAnswers(data);
    apiErrorHandler(answerData);
    return answerData;
}


/**
 * Backup local inline exercise data to remote
 * @param data
 * @returns {Promise<*>}
 */
const saveInlineHtmlAnswers = async(record) => {

    let file_list = [];

    //populate file_list
    for (let item of record.inlineExercise) {
        file_list.push(
            {
                data:item.content,
                filename:item.exercisecode,
                type:0
            }
        )
    }

    //prepare the data format to pass to api:
    let data = {
        ebookcode: localStorage.ebookcode,
        file_list: file_list,
        membercode: localStorage.membercode
    }

    return await syncApi.saveInlineHtmlAnswers(data);
}


/**
 * Redraw on the canvas using the restored data, and render notes, used in restore process
 */
const restoreToolHistoryToView = (restoredData)=> {

    let remoteHistory = {};

    for (let data of restoredData) {
        apiErrorHandler(data);
    }

    //Important note: clearAllCanvases invoke canvas context clearRect, which is very expensive,
    //it may cause memory leak in tablet. On tablet device, refresh the browser after data restore instead
    if (!isTouchDevice()) {
        useTool().clearAllCanvases();
        useTool().clearAllNotes();
    }

    for (let pageData of restoredData) {
        for (let [page, history] of Object.entries(pageData.data)) {
            //note that pagenum from the local history is not zero-based, so minus one for getCanvas, which uses zero-based
            let pagenum = parseInt(page) - 1;

            if (!isTouchDevice()) {
                useTool().restoreBrushHistory(useTool().getCanvas(`tool-canvas-left-${pagenum}`), history, pagenum);
                useTool().restoreNoteHistory(history, pagenum);
            }

            //pagenum is now zero-bsed and all even number page should have right-hand-side canvas to restore:
            if (pagenum % 2 === 1) {
                if (!isTouchDevice()) {
                    useTool().restoreBrushHistory(useTool().getCanvas(`tool-canvas-right-${pagenum}`), history, pagenum);
                }
            }

            remoteHistory[page] = history;
        }
    }

    return remoteHistory;
}

/**
 * Updated bookmark history from restored data
 * @param history
 * @returns {Promise<void>}
 */
const restoreBookmarkHistoryToView  = async (history)=>{
    //changed back to integer value for local db. String is used for app version backward compatibility...
    history = history.map(el=> { return parseInt(el); });
    await useBookmark().restoreBookmarkHistory(history, true)
}


/**
 * backup data to server
 */
const backup = async ()=>{

    let promptMsg;
    let updateTime;
    let isConfirmBackup;

    const remotePagesWithHistory = await getPagesWithHistory();
    console.log("@submit backup data remotePagesWithHistory:");
    console.log(remotePagesWithHistory)

    const record = await getCurrentLocalHistory();

    //backup only if there are changes to drawing / notes / bookmarks
    if (((record.toolHistory || record.inlineExercise)  && record.pagesWithLocalChange) || (record.bookmark && record.isBookMarkChanged)) {

        const updateTimeData = await syncApi.getUpdateTime();
        apiErrorHandler(updateTimeData);

        const hasData = updateTimeData.data.hasdata;

        if (hasData === "true") {
            updateTime = new Date(updateTimeData.data.updatetime.replace(/-/g, '/'));
            updateTime.setUTCHours(updateTime.getUTCHours() + 8);

            promptMsg = i18n.t("info_msg_backup_confirm", {updateTime:updateTime})
            isConfirmBackup = window.confirm(promptMsg);
        }

        if (isConfirmBackup || hasData === "false") {
            await submitBackupData(record);
        }


    } else {
        alert(i18n.t("info_msg_backup_restore_null"))
    }

}

/**
 * Prepare backup data and submit to server.
 * @returns {*}
 */
const submitBackupData = async (record)=> {

    console.log("@submitBackupData")
    console.log(record)
    let backupData = {};
    backupData["LastReadKey"] = record.lastRead;
    backupData["bookmark"] = record.bookmark;
    backupData["page"] = {};

    //Note that the page key in pagesWithLocalChange is one-based
    if (record.pagesWithLocalChange) {
        for (let page of record.pagesWithLocalChange) {
            //toolHistory does not exist if only inline exercise has changes, so check if toolHistory exists
            if (record.toolHistory && record.toolHistory[page] ) {
                backupData["page"][page] = record.toolHistory[page];
                delete backupData["page"][page].edat;
                delete backupData["page"][page].record;
                delete backupData["page"][page].whitebhoard;
            }
        }
    }

    console.log("backupData ready, before deleting those exist in remote but not local!")
    console.log(backupData)
    console.log(JSON.stringify(backupData))

    const remotePagesWithHistory = await getPagesWithHistory();
    console.log("@submit backup data remotePagesWithHistory:");
    console.log(remotePagesWithHistory)
    const brushIndexes = remotePagesWithHistory.data.brushindexes;
    const noteIndexes = remotePagesWithHistory.data.noteIndexes;


    //Note that page key in localHistory db is one-based.
    //Check to see if any pages that have remote data, but not local. This happens if user hasn't restored the latest backup version first
    //before attempting to backup. In this case, those remote data will be overwritten since the current local data is expected to be newer.
    //So we delete those page data that exists in the remote side but not local:
    if (brushIndexes) {
        if (record.toolHistory) {
            for (let index of brushIndexes) {
                if (!record.toolHistory[String(index)]) {
                    console.log("yes! page draw data that exists in the remote side but not local: " + index)
                    backupData["page"][String(index)] = {brush: [], note: []}
                }
            }
        }
    }

    if (noteIndexes) {
        if (record.toolHistory) {
            for (let index of noteIndexes) {
                if (!record.toolHistory[String(index)]) {
                    console.log("yes! page note data that exists in the remote side but not local: " + index)
                    backupData["page"][String(index)] = {brush: [], note: []};
                }
            }
        }
    }

    console.log("backupData, before reformat note:");
    console.log(backupData)
    console.log("backupData ready,final:")
    reFormatNoteData(backupData)
    console.log(JSON.stringify(backupData))
    console.log("backupdata.page:")
    console.log(JSON.stringify(backupData.page))

    //backup page data is empty if no drawing/note recorded, but only inline exericse:
    if (JSON.stringify(backupData.page) !== "{}" || backupData.bookmark) {
        const backupPromise = await syncApi.backupToServer(backupData);
        apiErrorHandler(backupPromise);
    }

    if (record.inlineExercise &&  record.inlineExercise.length) {
        const inlineExPromise = await saveInlineHtmlAnswers(record);
        apiErrorHandler(inlineExPromise);
    }
    await setLocalUnChanged();
    alert(i18n.t("info_msg_backup_success"));
}

/**
 * Format the backup data so that it's compatible with the app version.
 */
const reFormatNoteData = (backupData) => {
    console.log("@reFormatNoteData");
    console.log(backupData.page);

    if (Object.keys(backupData.page).length) {
        for (let [key, value] of Object.entries(backupData.page)) {
            if (value.note) {
                value.note = value.note.map(el => {
                    return {
                        contentX: el.x,
                        contentY: el.y,
                        iconX: el.minPosX,
                        iconY: el.minPosY,
                        title: el.title,
                        content: el.content,
                        isMaximized: el.isMaximized,
                        x:el.x,
                        y:el.y,
                        minPosX: el.minPosX,
                        minPosY: el.minPosY,
                        id:el.id
                    }
                })
            }
        }
    }
}

/**
 * Some attributes have to be defined if data hasn't been saved to the current page before,
 * so that the sync data will be compatible with app version.
 */
const getInitAttribute = ()=>{
    return {
        brush:[],
        note: []
        //record: [],
        //whiteboard: [],
        //edat: [{}]
    }
}


export {restore, backup, getInitAttribute}